export default __webpack_public_path__ + "static/media/ses_1.daf348c0.webp";